import { memo } from 'react';

import { EducationModal, EducationPage } from '../../education.typing';
import { EducationLevel } from '../education-level';

import { SelectEducationTutorial } from './select-education-tutorial';
import { SelectEducationLevelStyles as Styles } from './select-education.styles';
import { getRenderedLevelsProps } from './select-education.utils';
import { SELECT_EDUCATION_IDS } from './select-education.const';

import {
  IUseSelectEducationProps,
  useSelectEducation,
} from './select-education.state';

interface IProps extends IUseSelectEducationProps {
  setLevel: (level: string) => void;
  setModal: (modal?: EducationModal) => void;
  setPage: (page: EducationPage) => void;
}

export const SelectEducation = memo((props: IProps) => {
  const { clearEducationState, setLevel, setModal, setPage } = props;

  const { educationLevels, isGamifiedEducation, isEducationRestricted } =
    useSelectEducation({
      clearEducationState,
    });

  const RenderLevels = getRenderedLevelsProps({
    educationLevels,
    isEducationRestricted,
    isGamifiedEducation,
  }).map(
    (levelProps, index) =>
      levelProps && (
        <EducationLevel
          key={levelProps.level}
          id={index === 0 ? SELECT_EDUCATION_IDS.LEVEL : undefined}
          isLarge={isEducationRestricted}
          setLevel={setLevel}
          setModal={setModal}
          setPage={setPage}
          {...levelProps}
        />
      )
  );

  return (
    <Styles.Root>
      <SelectEducationTutorial />

      <Styles.ResponsiveContainer
        id={SELECT_EDUCATION_IDS.LEVELS}
        $isFullCentered={isEducationRestricted}
      >
        {RenderLevels}
      </Styles.ResponsiveContainer>
    </Styles.Root>
  );
});
